import MainContainer from '../main-container';
import Form from './customerForm';
import List from './customerList';
import { paths } from '../../config';

const settings = {
    pathRegister: paths.customerRegister,
    pathList: paths.customer,
    apiPath: 'customer',
    permissionAdmin: null,
    title: 'Clientes',
};

const Customer: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={{ ...settings, title: 'Cliente' }} />
        </MainContainer>
    );
};
const CustomerList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { Customer, CustomerList };
